import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Importar traducciones
import es from '../locales/es.json';
import en from '../locales/en.json';

const resources = {
  es: {
    translation: es
  },
  en: {
    translation: en
  }
};

i18n
  .use(initReactI18next) // Pasar i18next a react-i18next
  .init({
    resources,
    lng: 'es', // Idioma por defecto
    fallbackLng: 'es', // Idioma de respaldo
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false, // React ya escapa por defecto
    },

    // Configuración de detección automática del idioma
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

export default i18n; 